import * as React from 'react';
import { Text, Icon, iconsMap, Button } from '../..';
import { namespacedClassnames } from '../../common';
import { compKey } from './key';
export var FloatingNotification = function (props) {
    var maybeActionContainer = props.ctaText ? (React.createElement("div", { className: 'action-container' },
        React.createElement("div", { className: 'action' },
            React.createElement(Text, { className: 'cta-text', color: 't60', type: 'ts' }, props.ctaText)))) : null;
    return (React.createElement("div", { className: namespacedClassnames(compKey, props.isUrgent ? 'urgent' : undefined, { 'has-action': !!props.onClick }) },
        React.createElement("div", { className: 'header-container' },
            React.createElement(Text, { className: 'header', color: props.isUrgent ? 't01' : 't40', type: 'ts' }, props.header),
            React.createElement(Button, { className: 'cta-close', onClick: props.onClose, type: 'tertiary' },
                React.createElement(Icon, { className: 'cta-close-icon', icon: iconsMap.mediumX }))),
        React.createElement("div", { className: 'body', onClick: props.onClick },
            React.createElement("div", { className: 'icon-container' }, props.icon),
            React.createElement("div", { className: 'content' },
                React.createElement(Text, { className: 'title' }, props.title),
                React.createElement(Text, { className: 'description', color: 't40', type: 'ts' }, props.description)),
            maybeActionContainer)));
};
//# sourceMappingURL=index.js.map